import React from 'react'
import classes from './Global.module.css'

function GoogleLoginButton(renderProps) {
  return (
    <button onClick={renderProps.onClick} disabled={renderProps.disabled} className={`button ${classes.social_login_btn} ${classes.googleplus_button}`} href="#">
        <i className={`${classes.icon} fa-brands fa-google-plus-g`}></i><em>Login With</em> Google Plus
    </button>
  )
}

export default GoogleLoginButton